<template>
  <component
    :is="com"
    :grid="grid"
    :editType="editType"
    :clickEventManger="clickEventManger"
  ></component>
</template>
<script>
export default {
  name: 'grid-item',
  data: function () {
    return {
      com: null
    }
  },
  watch: {
    grid: {
      deep: true,
      async handler (newVal) {
        this.com = newVal ? (await import(`./${newVal.type}`)).default : null
      },
      immediate: true
    }
  },
  props: {
    grid: {
      type: Object
    },
    editType: {
      type: Boolean
    },
    clickEventManger: {
      type: Object
    }
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/common/student-status-card/components/StatusCard/components/Grid/index.vue